import InfoPatientRight from '../../../../../phan-he-kham-benh/components/InfoPatientRight';
import Actions from './Actions';

type Props = {
	benhNhanInfo: any;
	onClose: () => void;
};

const VatTuHeader = ({ benhNhanInfo, onClose }: Props) => {
	return (
		<div className="d-flex justify-content-between gap-6 w-100">
			<Actions onClose={onClose} />
			<InfoPatientRight benhNhanInfo={benhNhanInfo} />
		</div>
	);
};

export default VatTuHeader;
